import React                     from 'react';
import { observer }              from 'mobx-react-lite';
import View                      from '@widesk-ui/components/View';
import Link                      from '@widesk-ui/components/Link';
import Popover                   from '@widesk-ui/components/Popover';
import { DownOutlined }          from '@ant-design/icons';
import FileImage                 from '@/components/FileImage';
import ProjectMenu               from '@/TokamapEditor/ux/Header/ProjectMenu';
import currentProjectEditorStore from '@/TokamapEditor/stores/currentProjectEditorStore';
import appStore                  from '@/stores/appStore';
import useIsMobile               from '@/hooks/useIsMobile';

// Le compte puis le projet : le titre de la carte courante, lui, est porté par le bouton flottant
// « cartes » posé sur le plan (voir `MapButton`).
const HeaderTitle = observer(() => {
	const project = currentProjectEditorStore.get;
	const account = appStore.account;
	const [homeHovered, setHomeHovered] = React.useState(false);
	const [menuOpened, setMenuOpened] = React.useState(false);
	const isMobile = useIsMobile();

	if (!project) {
		return null;
	}

	// Lire `imageFile` déclenche sa résolution. Tant qu'elle n'a pas abouti — ou si le projet n'a
	// pas d'image — on n'affiche rien plutôt qu'un placeholder, qui ferait une tache claire dans le
	// bandeau sombre.
	const imageFile = project.project.imageFile;

	return (
		// Pas de `centerV` sur cette rangée : le trait du `splitSeparator` n'a pas de hauteur propre et
		// compte sur l'étirement pour se dessiner. Chaque segment se centre donc lui-même.
		<View row splitSeparator style={{ minWidth: 0 }}>
			{/* Un seul barreau pour une seule destination : la page d'accueil ne liste que les projets du
			    compte sélectionné (voir `HomePage`, filtré sur `owner.accountUrn`). */}
			{!isMobile && (
				<View centerV>
					<Link
						to="/"
						style={{ color: 'white', textDecoration: homeHovered ? 'underline' : 'none' }}
						onMouseEnter={() => setHomeHovered(true)}
						onMouseLeave={() => setHomeHovered(false)}
					>
						{account ? account.renderName() : 'Accueil'}
					</Link>
				</View>
			)}

			<View centerV style={{ minWidth: 0 }}>
				<Popover
					trigger="click"
					placement="bottomLeft"
					autoAdjustOverflow={{ shiftX: true }}
					open={menuOpened}
					onOpenChange={setMenuOpened}
					// Toujours fourni, jamais `null` : antd escamote le popover quand son contenu est vide,
					// et le déclencheur devient inerte. La `key` le remonte à chaque ouverture — la liste se
					// rafraîchit et la recherche repart à vide — et le contenu n'est monté qu'à la première
					// ouverture, donc aucune requête n'est tirée tant que le menu n'a pas servi.
					content={<ProjectMenu key={menuOpened ? 'open' : 'closed'} onSelect={() => setMenuOpened(false)} />}
					styles={{ body: { padding: 0 } }}
				>
					<View
						row
						centerV
						gap="xs"
						px="xs"
						py={2}
						br={6}
						pointer
						bg={menuOpened ? 'rgba(255,255,255,0.12)' : undefined}
						hover={{ bg: 'rgba(255,255,255,0.12)' }}
					>
						{!!imageFile.id && (
							<FileImage
								key={imageFile.urn}
								file={imageFile}
								size="small"
								fit="cover"
								borderRadius={4}
								preview={false}
							/>
						)}

						<span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
							{project.project.renderName()}
						</span>

						<DownOutlined
							style={{ fontSize: 10, opacity: 0.55, transition: 'transform .2s ease' }}
							rotate={menuOpened ? 180 : 0}
						/>
					</View>
				</Popover>
			</View>
		</View>
	);
});

export default HeaderTitle;
